import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

export const getResultStatus = (state: TInitialState): EResultPopupStatus => state.result.status;
